import { setDefaultCoApplicantsOtherPropertiesIncludeInTds, setDefaultMainApplicantOtherPropertiesIncludeInTds, setDefaultPropertyIncludeInTds, setDefaultQuailifiyinhDetailsAmortizationYears, setDefaultSubmissionDetailsAmortization, setDefaultSubmissionDetailsCompoundedPeriod, setDefaultSubmissionDetailsLoanType, setMainApplicantCoapp, setDefaultCoApplicantsId, setDefaultMainApplicantPreferredLanguage, setDefaultCoApplicantsPreferredLanguage, setDefaultSubjectPropertyExistingMortgagesPayoff, setDefaultSubjectPropertyExistingMortgagesPayoffEmpty, setDefaultPropertyValue } from "@Shared/@Utils/application-defaults-utils/application-transform-functions";
import { runSafeApplicationTransform } from "@Shared/@Utils/application-defaults-utils/util-functions";
export default [{
  transform: runSafeApplicationTransform(setMainApplicantCoapp,
  // set main applicant > coapp when filling empty application
  setDefaultMainApplicantPreferredLanguage // main applicant > preferred language to "english" when filling empty application
  ),
  rootPath: "main-applicant",
  triggerOnLoad: true
}, {
  transform: runSafeApplicationTransform(setDefaultSubmissionDetailsAmortization,
  // set submission details > submission details >  amortization years when filling empty application
  setDefaultQuailifiyinhDetailsAmortizationYears,
  // set submission details > qualifying details > amortization years when filling empty application
  setDefaultSubmissionDetailsCompoundedPeriod,
  // set submission details > submission details >  compounded period when filling empty application
  setDefaultSubmissionDetailsLoanType // set submission details > submission details >  loan type when filling empty application
  ),
  rootPath: "submission-details",
  triggerOnLoad: true
}, {
  // set property > costs >  include in tds  when filling empty application
  transform: runSafeApplicationTransform(setDefaultPropertyIncludeInTds),
  rootPath: "property",
  triggerOnLoad: true
}, {
  transform: runSafeApplicationTransform(setDefaultSubjectPropertyExistingMortgagesPayoff, setDefaultSubjectPropertyExistingMortgagesPayoffEmpty),
  rootPath: "property",
  triggerOnLoad: true,
  triggerOnSave: true
}, {
  // set main applicant > property > costs >  include in tds when adding new other property
  transform: runSafeApplicationTransform(setDefaultMainApplicantOtherPropertiesIncludeInTds),
  rootPath: "main-applicant",
  paths: ["[main-applicant][other-properties]"],
  triggerOnAddition: true
}, {
  // set co applicant > property > costs >  include in tds when adding new other property
  transform: runSafeApplicationTransform(setDefaultCoApplicantsOtherPropertiesIncludeInTds),
  rootPath: "co-applicants",
  paths: ["[co-applicants][X][other-properties]"],
  triggerOnAddition: true
}, {
  transform: runSafeApplicationTransform(setDefaultCoApplicantsId,
  // set a default co applicant id
  setDefaultCoApplicantsPreferredLanguage // set co-applicants > other income > income-period to "annual" when adding other incomes
  ),
  rootPath: "co-applicants",
  paths: ["[co-applicants]"],
  triggerOnAddition: true,
  triggerOnLoad: true
}, {
  transform: runSafeApplicationTransform(setDefaultPropertyValue),
  rootPath: "property",
  triggerOnLoad: true
}];